import { render, staticRenderFns } from "./ExtraInfoPanel.vue?vue&type=template&id=4b61efcb&scoped=true&"
import script from "./ExtraInfoPanel.vue?vue&type=script&lang=ts&"
export * from "./ExtraInfoPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraInfoPanel.vue?vue&type=style&index=0&id=4b61efcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61efcb",
  null
  
)

export default component.exports